import { createContext, useContext, useMemo, useReducer, useEffect } from "react"

import useGetAllLanguages from "api/querries/content/useGetAllLanguages"
import useGetKeywords from "api/querries/content/useGetKeywords"


import { IUIContext, IUIProvider, TModalTypes } from "./UIProviderTypes"
import { UI_INITIAL_CONTEXT, UI_INITIAL_STATE } from "./UIProviderConstants"
import { LANGS } from "types/shared"
import { getItemFromLocalStorage, setItemToLocalStorage } from "utils/localStorage"

export const UIContext = createContext<IUIContext>(UI_INITIAL_CONTEXT)

export const useUI: () => IUIContext = () => useContext(UIContext)

const UIProvider: React.FC<IUIProvider> = ({ children }) => {
  const token = getItemFromLocalStorage("token")
  const hasToken = Boolean(token)


  // @ts-ignore
  const [state, setState] = useReducer(
    (oldState: any, newState: any) => ({ ...oldState, ...newState }),
    UI_INITIAL_STATE,
  )
  const { data: languagesData } = useGetAllLanguages((state.languages.length === 0 && hasToken))
  const { data: keywordsData } = useGetKeywords(state.lang, state.keywords[state.lang] === null)

  const toggleModal = (key: TModalTypes, opened: boolean, data?: any, id?: string, closeAll?: boolean) => {
    let updatedModals = { ...state.modals }

    if (closeAll) {
      updatedModals = { ...UI_INITIAL_STATE.modals, [key]: { ...state.modals[key], data, id, isOpened: opened } }
    } else {
      updatedModals = { ...state.modals, [key]: { ...state.modals[key], isOpened: opened, data, id } }
    }

    setState({ modals: updatedModals })
  }

  const handleLanguageChange = (lang: LANGS) => {
    setState({ lang })
    setItemToLocalStorage("lang", lang)
  }

  const T = (key: string) => state.keywords[state.lang] && state.keywords[state.lang][key] || key

  useEffect(() => {
    if (keywordsData) {
      setState({ keywords: { ...state.keywords, [state.lang]: keywordsData } })
    }
  }, [keywordsData])

  useEffect(() => {
    if (languagesData) {
      setState({ languages: languagesData })
    }
  }, [languagesData])

  // useEffect(() => {
  //   const currentLang = getItemFromLocalStorage("lang")
  //   if (currentLang) {
  //     setState({ lang: currentLang })
  //   }
  // }, [])

  useEffect(() => {
    // This return function will be called when the component unmounts
    return () => {
      // Switch between 'ka' and 'en' when unmounting and store it in localStorage
      if (state.lang === LANGS.KA) {
        setItemToLocalStorage("lang", LANGS.EN);
      } else {
        setItemToLocalStorage("lang", LANGS.KA);
      }
    };
  }, [state.lang]);


  const data = useMemo(
    () => ({ ...state, toggleModal, handleLanguageChange, T }),
    [state.modals, state.languages, state.keywords, state.lang],
  )

  return <UIContext.Provider value={data}>{children}</UIContext.Provider>
}

export default UIProvider
